import usePermissions from "hooks/usePermissions";
import AddressTable from "./AddressTable";
import AddressV2Table from "./AddressV2Table";

const AddressBook = function () {
  const { permissions } = usePermissions();
  const { enable_new_address_structure } = JSON.parse(permissions).company_shipper_settings;

  if (!enable_new_address_structure) {
    return <AddressTable />;
  }
  return <AddressV2Table />;
};

export default AddressBook;
